const getMiliSecondDuration = (createdTimestamp) => {
  return new Date().getTime() - parseInt(createdTimestamp, 10);
};

export default getMiliSecondDuration;
